import { Component, Inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { CommonDialog } from '../../models/common-dialog.model';

@Component({
  selector: 'app-common-yes-no-dialog',
  templateUrl: './common-yes-no-dialog.component.html',
})
export class CommonYesNoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CommonDialog,
    public dialog: MatDialog,
    public translate: TranslateService
  ) {}
}
